import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import point from './modules/point'
import message from './modules/message'
import category from './modules/category'
import location from './modules/location'
import company from './modules/company'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfoYs: {},
        selectZcCompantyName: '',
        cydnToken:'',
    },
    modules: {
        user,
        point,
        message,
        category,
        location,
        company,
    }
})
